import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/Index"),
  },
  {
    path: "/check/:token",
    name: "login",
    component: () => import("../views/login/Token"),
  },
  {
    path: "/logout",
    name: "logout",
    component: () => import("../views/login/Logout"),
  },
  {
    path: "/gestion/transferencias-monetarias",
    name: "transferencias",
    component: () => import("../views/gestion/Transferencias"),
  },
  {
    path: "/gestion/cbu-asociados",
    name: "cbus",
    component: () => import("../views/gestion/CbuAsociados"),
  },
  {
    path: "/gestion/external-accounts",
    name: "external_accounts",
    component: () => import("../views/gestion/ExternalAccounts"),
  },
  {
    path: "/no-puede-operar",
    name: "no_operar_transferencias",
    component: () => import("../views/gestion/NoOperarTransferencias"),
  },
  {
    path: "/mantenimiento",
    name: "mantenimiento",
    component: () => import("../views/gestion/Mantenimiento"),
  },
  {
    path: "/user-bloqueado",
    name: "bloqueado",
    component: () => import("../views/gestion/Bloqueado"),
  },
  {
    path: "/user-sesion-expirada",
    name: "expired",
    component: () => import("../views/gestion/SessionExpired"),
  },
  {
    path: "/user-token-invalido",
    name: "token_error",
    component: () => import("../views/gestion/TokenError"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
